import React, { FormEvent, useCallback, useContext, useState } from "react";
import { ApplicationContext } from "../../../../components/ApplicationProvider";
import {
    Container,
    Message,
    SearchButton,
    SearchForm,
    SearchInput,
} from "./CSEGatewaySerialSearch.style";

interface PrinterSerialSearchProps {
    isCSE: boolean;
    onSearch: (printerSerial?: string) => void;
}

const CSEGatewaySerialSearch: React.FC<PrinterSerialSearchProps> = ({ isCSE, onSearch }) => {
    const { t } = useContext(ApplicationContext);

    const [printerSerial, setPrinterSerial] = useState("");

    const isSearchDisabled = !printerSerial.trim();

    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
        setPrinterSerial(event.target.value);
    }, []);

    const handleSubmit = useCallback(
        (event: FormEvent<HTMLFormElement>): void => {
            event.preventDefault();

            const serial = printerSerial.trim();

            onSearch(serial || undefined);
        },
        [onSearch, printerSerial]
    );

    return (
        <Container>
            {isCSE && (
                <Message data-testid="cse-banner">{t("gateways.cse_add_gateway_message")}</Message>
            )}

            <SearchForm onSubmit={handleSubmit} data-testid="printer-serial-search-form">
                <SearchInput
                    id="printer-serial-input"
                    type="text"
                    autoComplete="off"
                    placeholder={t("devices.gateways.search_by_printer_serial_number")}
                    data-testid="printer-serial-input"
                    value={printerSerial}
                    onChange={handleChange}
                />
                <SearchButton
                    type="submit"
                    data-testid="printer-serial-search-button"
                    disabled={isSearchDisabled}
                >
                    {t("gateways.find_gateways")}
                </SearchButton>
            </SearchForm>
        </Container>
    );
};

export default CSEGatewaySerialSearch;
